// extracted by css-extract-rspack-plugin
export default {"SpoofedCommitWarningBanner":"SpoofedCommitWarning-module__SpoofedCommitWarningBanner__L_TkOuY"};